import { Component, Vue } from 'vue-property-decorator'
import { editApplyInfo, queryClassSummary, evaluationPlanBsellOrderId, queryClassPaperSend } from '@/api'
import paperFeedBack from '@/components/paperFeedBack/index.vue'
import merge from 'webpack-merge'
@Component({ name: 'class-detail-page', components: { paperFeedBack } })
export default class ClassDetailPage extends Vue {
  private queryobj: any = {}
  private classData: any = {}
  private activeweek: any = 0
  private paperDelivery: any = null
  private classPaperData: any = null
  private applyType: any = '空'
  private applyDetail: any = ''
  private sellOrderId: any = ''
  private applySelectList: any = ['空', '有', '无', '待定', '不建议', '需学生自行与教授确认']

  created () {
    const obj: any = {
      studentId: this.$route.query.studentId,
      sellOrderId: this.$route.query.sellOrderId,
      classId: this.$route.query.classId
    }
    this.queryobj = obj
    this.sellOrderId = this.$route.query.sellOrderId
    this.applyType = this.$route.query.applyType
    this.applyDetail = this.$route.query.applyDetail
    this.initPageData()
    this.initClassPaperSend()
  }

  async initPageData () {
    const result: any = await queryClassSummary({ classId: this.$route.query.classId, sellOrderId: this.$route.query.sellOrderId })
    this.classData = result
    const result1: any = await evaluationPlanBsellOrderId({ classId: this.$route.query.classId, sellOrderId: this.$route.query.sellOrderId })
    this.paperDelivery = result1
  }

  private async initClassPaperSend () {
    const result = await queryClassPaperSend({ classId: this.$route.query.classId })
    this.classPaperData = result
  }

  private async saveApplyInfo (item: any) {
    const { error }: any = await editApplyInfo({
      sellOrderId: this.sellOrderId,
      applyType: this.applyType,
      applyDetail: this.applyDetail
    })
    if (!error) {
      this.$message({ message: '修改Course Code成功', type: 'success' })
      const _query: any = { query: merge(this.$route.query, { applyType: this.applyType, applyDetail: this.applyDetail }) }
      this.$router.push(_query)
    }
  }
}
